import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { createInstance, Piral, createStandardApi } from 'piral';
import { layout, errors } from './layout';
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import 'typeface-titillium-web';
import 'typeface-roboto-mono';
import 'typeface-lora';
import { AuthProvider } from './ms-identity/AuthContext';
import { saveLogUtility, searchLogUtility } from './utility/logUtility';
import { ILogCreate, ILogDocument, UserInfo } from './interfaces/interfaces';
import { fetchFromBFF } from './utility/bffUtility';


declare module 'piral-core/lib/types/custom' {
    interface PiralCustomState {
        custom: {
            user: any;
            real_user: any;
            switched: boolean;
        };
    }
}

interface MyApi {
    getUserInfo(): Promise<UserInfo | null>;
    saveLog(logData: ILogCreate): Promise<void>;
    searchLog(piletName: string, level: string, searchTerm: string): Promise<ILogDocument>;
}

declare module 'piral-core/lib/types/custom' {
    interface PiletCustomApi extends MyApi { }
}

function createMyApi() {
    return (context) => ({

        async getUserInfo() {

            var userInfo: UserInfo | null = null;
            const state = context.readState((s) => s.custom);
            const user = state?.user;

            if (user) {
                userInfo = {
                    name: user.displayName,
                    username: user.userPrincipalName,
                    matricola: user.onPremisesSamAccountName ?? null,
                    cn: user.cn ?? null,
                    roles: user.roles ?? [],
                    personale: user.personale
                };
            }

            //console.log(userInfo);   
            return userInfo;
        },

        async saveLog(logData: ILogCreate) {
            saveLogUtility(logData);
        },

        async searchLog(piletName: string, level: string, searchTerm: string) {
            return await searchLogUtility(piletName, level, searchTerm);
        }
    });
}

const instance = createInstance({
    state: {
        components: layout as any,
        custom: { user: null }, // Stato iniziale
        errorComponents: errors
    },
    plugins: [createMyApi(), ...createStandardApi()],
    async requestPilets() {
        const endpoint = 'control-panel/pilet-list';

        // Se sei in sviluppo locale, puoi anche bypassare direttamente la chiamata al BFF per i pilet
        if (process.env.NODE_ENV === 'development') {
            console.warn("Sviluppo locale: salto la richiesta dei pilet al BFF.");
            return [];
        }

        return await fetchFromBFF(endpoint, { method: "GET" })
            .then(r => {
                if (r && Array.isArray(r)) {
                    r.forEach((element: { link: string; name: string; }) => {
                        element.link = (process.env.LOGIN_REDIRECT_URI || '') + element.name + "/index.js";
                    });
                    return r;
                }
                return []; // Ritorna sempre un array se la risposta non è valida
            })
            .catch(error => {
                console.error("Errore durante il recupero dei pilet dal BFF: ", error);
                return []; // FONDAMENTALE: ritorna un array vuoto anziché undefined per non bloccare Piral!
            });
    },
});


// React root component
const root = ReactDOM.createRoot(document.querySelector('#app') as HTMLElement);

// We recommend wrapping most or all of your components in the MsalProvider component. It's best to render the MsalProvider as close to the root as possible.
root.render(
    <AuthProvider instance={instance}>
        <Piral instance={instance} />
    </AuthProvider>
);
